import React from 'react';
import { AppBar, Box, Typography } from '@mui/material';

function CourseStepper({ coursesSteps, currentStep, stepsTitles }) {
    const currentTitle = stepsTitles[currentStep] || '';

    return (
        <AppBar 
            position="sticky" 
            sx={{ 
                background: "linear-gradient(135deg, #212529 0%, #343a40 100%)", 
                bottom: 0, 
                borderBottom: "3px solid #dc3545",
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                zIndex: 1000,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '60px',
                    width: '100%',
                    px: { xs: 1, sm: 2 },
                    textAlign: 'center'
                }}
            >
                <Typography
                    variant="h6"
                    component="div"
                    sx={{
                        color: '#fff',
                        fontWeight: 700,
                        letterSpacing: '0.5px',
                        textTransform: 'uppercase',
                        fontSize: { xs: '0.85rem', sm: '0.95rem', md: '1rem' },
                        textAlign: 'center',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        width: '100%',
                        maxWidth: '100%',
                        px: { xs: 1, sm: 2 },
                        margin: 0
                    }}
                >
                    {currentTitle}
                </Typography>
            </Box>
        </AppBar >
    );
}

export default CourseStepper;
